import { current } from 'immer';
import type { CanvasState, SliceCreator } from '../types';
import { deepClone } from '../utils';
import type { SliceCtx } from '../ctx';

type SliceKeys = 'undo' | 'redo';

export const createHistorySlice: SliceCreator<Pick<CanvasState, SliceKeys>> = (set, get) => {
  const resolveCtx = (): SliceCtx | undefined => (get as any).__ctx;
  const ensureCtx = () => {
    const ctx = resolveCtx();
    if (!ctx) throw new Error('canvas ctx missing for history slice');
    return ctx;
  };

  return {
    undo: () => {
      const { bumpStructureVersion } = ensureCtx();
      set((state) => {
        const prev = state.ui.history.past.pop();
        if (!prev) return;
        state.ui.history.future.push({ nodes: state.graph.nodes, edges: state.graph.edges });
        state.graph.nodes = prev.nodes;
        state.graph.edges = prev.edges;
        bumpStructureVersion(state);
        state.ui.selection = { nodes: new Set(), edges: new Set() };
      });
    },
    redo: () => {
      const { bumpStructureVersion } = ensureCtx();
      set((state) => {
        const next = state.ui.history.future.pop();
        if (!next) return;
        const currNodes = current(state.graph.nodes);
        const currEdges = current(state.graph.edges);
        state.ui.history.past.push({ nodes: deepClone(currNodes), edges: deepClone(currEdges) });
        state.graph.nodes = next.nodes;
        state.graph.edges = next.edges;
        bumpStructureVersion(state);
        state.ui.selection = { nodes: new Set(), edges: new Set() };
      });
    },
  };
};
